module.exports = __webpack_public_path__ + "static/media/edit-pencil.adfb6ed5.svg";